import type { TOC } from '@ember/component/template-only';

interface QuickStartGuideSupportHelpCardSignature {
  Args: Record<string, never>;
  Element: HTMLDivElement;
}

const QuickStartGuideSupportHelpCard: TOC<QuickStartGuideSupportHelpCardSignature> =
  <template>
    <div
      class="card border shadow-sm rounded-4 h-100 text-center"
      ...attributes
    >
      <div
        class="card-body d-flex flex-column align-items-center justify-content-center p-4 p-lg-5"
      >
        <span
          class="ll-avatar-sm rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center flex-shrink-0 mb-3"
          aria-hidden="true"
        >
          <iconify-icon inline icon="ph:headset" class="fs-4" />
        </span>

        <h3 class="h5 fw-bold mb-2">Need more help?</h3>

        <p class="small text-body-secondary mb-4">
          Our support team can help with anything these guides don't cover.
        </p>

        <a
          href="mailto:v-support@hultashridge.com"
          class="btn btn-primary rounded-pill px-4 fw-semibold w-100"
        >
          Contact support
        </a>
      </div>
    </div>
  </template>;

export default QuickStartGuideSupportHelpCard;
